import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { RoutingService } from '@spartacus/core';
import { combineLatest } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { PermissionsConstants } from 'src/app/service/myaccount/my-account-permission.constants';
import { MyAccountPermissionService } from 'src/app/service/myaccount/my-account-permission.service';
import { MyaccountInfoService } from 'src/app/service/myaccount/myaccount-info.service';

@Injectable({
  providedIn: 'root',
})
export class MyAccountPermissionsAuthGuard implements CanActivate {
  constructor(
    private myAccountPermissionService: MyAccountPermissionService,
    private routingService: RoutingService,
    private myAccountInfoService: MyaccountInfoService
  ) {}

  canActivate() {
    return combineLatest([
      this.routingService.getNextPageContext().pipe(take(1)),
      this.myAccountPermissionService.currentUserPermissions$,
      this.myAccountInfoService.getMyAccountInfo(),
    ]).pipe(
      map(([pageContext, permissions, myAccount]: any) => {
        if (permissions?.length) {
          switch (pageContext.id) {
            case PermissionsConstants.ORDER_HISTORY_PAGE_ID:
              return permissions.includes(PermissionsConstants.VIEW_ORDER_HISTORY);
            case PermissionsConstants.ORDER_DETAILS_PAGE_ID:
              return permissions.includes(PermissionsConstants.VIEW_ORDER_HISTORY);
            case PermissionsConstants.CHECKOUT_PAGE_ID:
              return permissions.includes(PermissionsConstants.PLACE_ORDERS);
            case PermissionsConstants.EDIT_EMPLOYEE_PAGE_ID:
              return permissions.includes(PermissionsConstants.CREATE_EDIT_DELETE_USERS) && myAccount?.isB2BAdmin;
            default:
              return true;
          }
        } else if (permissions?.length === 0) {
          return false;
        }
      }),
      // hasPermission is default to true to catch if no storeFrontPermissions set in a country
      map((hasPermission: boolean = true) => {
        if (!hasPermission) {
          this.routingService.go({ cxRoute: 'home' });
        }
        return hasPermission;
      })
    );
  }
}
